import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import { postJodiacRequest, postJodiacRequestAccept } from "../services/api";
import { useParams, useNavigate } from "react-router-dom";
import Notiflix from "notiflix";

export default function Request() {
  const [jodiacRequest, setJodiacRequest] = useState(null);
  const [secretCode, setSecretCode] = useState("");
  const [verificationCode, setVerificationCode] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);
  const { id: uuid } = useParams();
  const [requestData, setRequestData] = useState(null);
  const didPostRef = useRef(false);
  const navigate = useNavigate();
  const handleBackToCategories = () => {
    document.cookie = "jodiacRequest=; Max-Age=0; path=/";
    const targetId = requestData?.request?.requester?.id || uuid;
    navigate("/" + targetId);
  };
  useEffect(() => {
    // 1) Çerezi oku
    const found = document.cookie
      .split(";")
      .map((c) => c.trim())
      .find((c) => c.startsWith("jodiacRequest="));

    const foundUuid = document.cookie
      .split(";")
      .map((c) => c.trim())
      .find((c) => c.startsWith("jodiacRequestUuid="));

    const value = found ? decodeURIComponent(found.split("=")[1] || "") : null;
    const valueUuid = foundUuid ? decodeURIComponent(foundUuid.split("=")[1] || "") : null;
    if (value) setJodiacRequest(value);

    const send = async () => {
      if (didPostRef.current) return; // StrictMode tekrarını engelle
      didPostRef.current = true;
      if (!value || !uuid) return;

      const data = {
        request_type: String(value),
        partner_card_id: uuid,
        memory_book_id: valueUuid ? valueUuid : null,
        message: ""
      };
      try {
        const response = await postJodiacRequest(data);
        setRequestData(response);
      } catch (err) {
        const apiMsg = err?.response?.data?.message || err?.message || "Bir hata oluştu";
        Notiflix.Notify.failure(apiMsg);
        // hatada çerezi temizleyip uuid sayfasına dön
        document.cookie = "jodiacRequest=; Max-Age=0; path=/";
        navigate("/" + uuid);
      }
    };
    send();
  }, []);


  const handleAccept = async () => {
    const code = verificationCode.join("");
    if (code.length !== 4) {
      Notiflix.Notify.failure("Lütfen 4 haneli kodu giriniz.");
      return;
    }
    setSecretCode(code);
    const data = {
      requested_uuid: uuid,
      request_id: requestData.request.id,
      secret_key: code
    };
    console.log("data", data);
    const response = await postJodiacRequestAccept(data);
    console.log("response", response);
Notiflix.Notify.success("İstek başarıyla onaylandı");
    // jodiacRequest çerezini temizle
    document.cookie = "jodiacRequest=; Max-Age=0; path=/";
    navigate("/" + response.request.requester.id);
  };

  return (
    <div className="min-h-screen bg-white  flex flex-col items-center">
          <div
        className="text-center h-[120px] w-full flex items-center justify-center"
        style={{
          backgroundImage: "url(/assets/pngImages/welcomeScreen.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <img
          src="/assets/pngImages/jodiacLogo.png"
          alt="JODIAC Logo"
          className="h-[150px] mb-4 w-auto"
        />
      </div>
      <div className="max-w-sm -mt-6 mx-auto w-full">
        <div className="bg-white rounded-3xl border border-gray-100 p-6 flex flex-col items-center text-center">
          <img src="/assets/pngImages/success.png" alt="Success" className="w-48 h-48 object-contain mb-4" />
          <p className="text-gray-800 font-semibold mb-1">İstek başarıyla gönderildi</p>
          <p className="text-gray-500 text-sm mb-4">Aşağıda alıcının gizli kodunu girerek isteği hemen onaylayabilirsiniz</p>

          <div className="w-full">
            <div className="flex justify-center gap-2 mb-4">
              {verificationCode.map((digit, idx) => (
                <motion.input
                  key={idx}
                  ref={(el) => (inputRefs.current[idx] = el)}
                  type="text"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 1 && /^[0-9]*$/.test(value)) {
                      const next = [...verificationCode];
                      next[idx] = value;
                      setVerificationCode(next);
                      if (value && idx < 3) inputRefs.current[idx + 1]?.focus();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" && !verificationCode[idx] && idx > 0) {
                      inputRefs.current[idx - 1]?.focus();
                    }
                  }}
                  className="w-[50px] h-[50px] rounded-lg text-center text-xl font-bold border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3DA7B5] bg-white"
                  initial={{ scale: 0.8, opacity: 0, y: 10 }}
                  animate={{ scale: 1, opacity: 1, y: 0 }}
                  transition={{ duration: 0.2, delay: idx * 0.1 + 0.2 }}
                />
              ))}
            </div>
            <button
              onClick={handleAccept}
              className="w-full px-4 py-3 rounded-xl bg-[#3DA7B5] text-white text-sm font-medium"
            >
              Onayla
            </button>
          </div>
        </div>
        <div className="flex flex-col justify-center items-center px-5 pb-4">
          <div className=" w-[179px] border-b border-[#E2E2E2] text-white text-sm">
            {" "}
            &nbsp;{" "}
          </div>
          <button onClick={handleBackToCategories} className="w-full mt-4 text-[#3DA7B5] font-medium">
            Kategorilere geri dön
          </button>
        </div>
      </div>
    </div>
  );
}